<!--
工单动态
 -->

<template>
  <div class="dynamic">
    <ul class="dynamic-list">
      <li class="item" v-for="(item, index) in listData">
        <div class="stage" v-if="false">
          <span class="text">—— 6月17日 20：15 物流运输已完成 ——</span>
        </div>
        <div class="box">
          <div class="circle">
            <img :src="item.userAvatar" :alt="item.userName">
          </div>
          <div class="user-name">{{item.userName}}</div>
          <div class="date-time">{{item.addTime | formatTimeCompare}}</div>
          <div class="infos">{{item.content}}</div>
          <ul class="img-list" v-if="item.images && item.images.length">
            <li class="thumb" v-for="img in item.images" @click="openLightbox(img)">
              <img :src="img+'_80x80.jpg'">
            </li>
          </ul>

          <div class="files" v-if="item.attchment && item.attchment.length">
            <attachment-preview :data="item.attchment"></attachment-preview>
            <!-- <a class="link" target="_blank" :href="getDownloadUrl(item.id,index)" v-for="(file,index) in item.attchment" download="">{{file.filename}}；</a> -->
          </div>
        </div>
        <div class="comment">
          <div class="item-options">
            <like :refId="item.id" refType="workOrder" v-if="isLikeShow === index"></like>
            <a
              href="javascript:;"
              class="option"
              :class="{'active': isLikeShow === index}"
              @click="handleLike(item.id, index, item.likeCount)"
              @mouseover="showLike(index)"
              @mouseout="hideLike()">
              <i class="icon" :class="[item.likeCount ? 'web-icon-thumbs-up' : 'web-icon-thumbs-up-o']"></i>
              <span class="text">点赞<em class="num" v-show="item.likeCount">({{item.likeCount}})</em></span>
            </a>
            <a href="javascript:;" class="option" :class="{'active': isCommentShow === index}" @click="handleReport(index)">
              <i class="icon" :class="[item.commentCount ? 'web-icon-comment' : 'web-icon-comment-o']"></i>
              <span class="text">评论<em class="num" v-show="item.commentCount">({{item.commentCount}})</em></span>
            </a>
          </div>
          <div class="comment-con" v-if="isCommentShow === index">
            <report :refId="id" :refCommentId="item.id" refType="workOrder"></report>
          </div>

        </div>
      </li>
      <li v-if="!listData.length" class="empty">暂无工单动态</li>
    </ul>

  </div>
</template>

<script>
import * as api from 'src/api'
import lightBox from 'src/plugins/lightbox'
import Report from 'components/common/report'
import Like from 'components/common/like-list'
import attachmentPreview from 'components/common/attachment-preview'

export default {

  name: 'dynamic',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      listData: [],
      isCommentShow: '',
      isLikeShow: '',
      apiUrl: api.path
    }
  },

  mounted () {
    this.getDynamic()
  },

  methods: {

    // 获取工单动态
    getDynamic () {
      let url = '/workOrder/getDynamic.html'
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.listData = data.result
      })
    },

    // 获取文件下载链接
    // getDownloadUrl (id, index) {
    //   if (id) {
    //     return `${this.apiUrl}/workOrder/load.html?id=${id}&index=${index}`
    //   }
    // },

    // 新增动态
    openAddnew () {

    },

    openLightbox (url) {
      lightBox(url)
    },

    // 展开或关闭评论
    handleReport (index) {
      if (this.isCommentShow === index) {
        this.isCommentShow = ''
      } else {
        this.isCommentShow = index
      }
    },

    // 点赞提交
    handleLike (id, index, count) {
      const url = '/likeApi/save.html'
      const params = {
        // 点赞类型，3 为跟进记录
        refType: 'comment',
        refId: id
      }
      api.post(url, params, (data) => {
        this.$set(this.listData[index], 'likeCount', count + 1)
      })
    },

    // 显示点赞的人
    showLike (index) {
      if (this.listData[index].likeCount) {
        this.isLikeShow = index
      }
    },

    // 隐藏点赞的人
    hideLike () {
      this.isLikeShow = ''
    }
  },

  filters: {
    formatTimeCompare (time) {
      return window.utils.formatTimeCompare(time)
    }
  },

  components: {
    Report,
    Like,
    attachmentPreview
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';

  .dynamic {
    .dynamic-list {
      .item {
        margin-bottom: 15px;
        .stage {
          text-align: center;
          padding: 12px;
          .text {
            font-size: 15px;
            color: @light-gray;
          }
        }
        .box {
          border: 1px solid #e5ecf7;
          border-radius: 4px 4px 0px 0px;
          padding: 15px 15px 15px 78px;
          box-sizing: border-box;
          position: relative;
          .circle {
            position: absolute;
            left: 15px;
            top: 15px;
            width: 48px;
            height: 48px;
            border-radius: 24px;
            overflow: hidden;
            background-color: #6EC7AD;
            color: #fff;
            font-size: 13px;
            img {
              width: 100%;
              height: 100%;
              display: block;
            }
          }
          .user-name {
            font-size: 16px;
            margin-top: 3px;
          }
          .date-time {
            font-size: 13px;
            color: @light-gray;
            margin-top: 8px;
          }
          .infos {
            margin-top: 8px;
            font-size: 14px;
            line-height: 24px;
          }
          .img-list {
            width: 105%;
            .thumb {
              width: 80px;
              height: 80px;
              margin-top: 15px;
              margin-right: 20px;
              background-color: #f9f9f9;
              cursor: pointer;
              display: inline-block;
              vertical-align: top;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .files {
            margin-top: 20px;
            padding-top: 25px;
            border-top: 1px dashed #d8d8d8;
            font-size: 13px;
            .name {
              display: inline-block;
              vertical-align: top;
            }
            .link {
              white-space: nowrap;
              vertical-align: top;
              display: inline-block;
              margin-right: 10px;
              color: @primary;
              cursor: pointer;
            }
          }
        }
        .comment {
          border: 1px solid #e5ecf7;
          border-top-width: 0;
          border-radius: 0 0 4px 4px;
          box-sizing: border-box;
          .item-options {
            position: relative;
            padding: 11px;
            text-align: right;
            background-color: #F7FBFF;
            font-size: 0;
            .option {
              font-size: 13px;
              display: inline-block;
              vertical-align: top;
              padding-right: 11px;
              margin-left: 10px;
              border-right: 1px solid #DCE1E8;
              color: @light-blue;
              cursor: pointer;
              position: relative;
              &:last-child {
                margin-right: 0;
                border-right-width: 0;
                padding-right: 0;
              }
              &:before {
                position: absolute;
                z-index: 2;
                content: '';
                width: 10px;
                height: 10px;
                top: 20px;
                left: 24px;
                background-color: #fff;
                box-shadow: 0 0 1px 1px #cdd9eb inset;
                transform: rotate(45deg);
                display: none;
              }
              &:after {
                position: absolute;
                z-index: 3;
                content: '';
                width: 12px;
                height: 7px;
                background-color: #fff;
                top: 25px;
                left: 23px;
                display: none;
              }
              &.active {
                &:before {
                  display: block;
                }
                &:after {
                  display: block;
                }
              }
              .icon {
                vertical-align: middle;
                font-size: 12px;
              }
              .text {
                margin-left: 2px;
                vertical-align: middle;
                display: inline-block;
                .num {
                  font-style: normal;
                }
              }
            }
          }
        }
      }
      .empty {
        text-align: center;
        line-height: 5;
      }
    }

  }
</style>

<style>
.dynamic-list .files .file-content .file-info {
  padding: 0;
  margin: 0;
  border-top: 0;
}
.dynamic-list .file-content .file-info .file-name {
  min-width: 256px;
}
</style>



// WEBPACK FOOTER //
// dynamic.vue?ab92f042